import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 0 40px;
  padding: 12px;
`;

export const Input = styled.input`
  padding: 7px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;

  color: #b6b6b6;
  background: #160c24;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px 0px 0px 6px;
`;

export const Select = styled.select`
  padding: 7px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;

  color: #b6b6b6;
  background: #160c24;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0px 6px 6px 0;
`;
